import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router';
import styles from './Kpi.module.css';

export interface KpiStripProps extends HTMLAttributes<HTMLDivElement> {
  /** Minimum column width token, 180–230. */
  min?: 180 | 190 | 220 | 230;
}

/** `repeat(auto-fit, minmax(190px, 1fr))`, minimum per strip. */
export function KpiStrip({ min = 190, style, children, ...rest }: KpiStripProps) {
  const vars = { '--min': `var(--minmax-${min})` } as CSSProperties;
  return (
    <div className={styles.strip} style={{ ...vars, ...style }} {...rest}>
      {children}
    </div>
  );
}

export interface KpiCardProps {
  label: ReactNode;
  figure: ReactNode;
  note?: ReactNode;
  tone?: 'default' | 'positive' | 'warning' | 'critical';
  size?: 'md' | 'lg';
  /** Renders the card as a tinted link. */
  to?: string;
  children?: ReactNode;
}

export function KpiCard({ label, figure, note, tone = 'default', size = 'md', to, children }: KpiCardProps) {
  const figureCls = [styles.figure, size === 'lg' ? styles.figureLg : '', tone !== 'default' ? styles[tone] : ''].filter(Boolean).join(' ');
  const body = (
    <>
      <div className={styles.label}>{label}</div>
      <div className={figureCls}>{figure}</div>
      {note && <div className={styles.note}>{note}</div>}
      {children}
    </>
  );
  if (to) {
    return (
      <Link to={to} className={`${styles.card} ${styles.link}`}>
        {body}
      </Link>
    );
  }
  return <div className={styles.card}>{body}</div>;
}
